import { render, staticRenderFns } from "./iDalgo-403.vue?vue&type=template&id=02ff73ff"
import script from "./iDalgo-403.vue?vue&type=script&lang=js"
export * from "./iDalgo-403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports